module.exports = __webpack_public_path__ + "static/media/frameGreen.ecc85b85.svg";